<!--  -->
<template>
	<div id="box">
		<bar></bar>
		<div class="home-main">
			
			<el-carousel height="1080px">
			    <el-carousel-item >
					<img class="app-banner" :src="app_banner" alt="">
			    </el-carousel-item>
			</el-carousel>
			
		</div>
		
		<myfooter ></myfooter>
	</div>
</template>

<script>
	import banner_pic01 from '@/assets/banner/home_banner_pic01_PC_1920x400.jpg';
	import banner_pic02 from '@/assets/banner/home_banner_pic02_PC_1920x400.jpg';
	import banner_pic03 from '@/assets/banner/home_banner_pic03_PC_1920x400.jpg';
	
	import liucheng from '@/assets/banner/liucheng.jpg';
	import hot from '@/assets/hot.gif';
	
	import app_banner from '@/assets/banner/banner_01.png';
	import app_banner_01 from '@/assets/banner/app_banner_01.png';
	import app_banner_03 from '@/assets/banner/app_banner_03.png';
	
	import myfooter from '@/components/myfooter/myfooter.vue'
	
	export default {
		components: {
			myfooter,
		},
		data() {
			return {
				app_banner,
				app_banner_01,
				app_banner_03,
				bannerPicList:[
					banner_pic01,
				],
				
				liucheng,
				hot,
				
				userData: "",
				activeIndex:"index",
			};
		},

		methods: {
			
			
		},
		mounted() {
			
		},

	};
</script>
<style scoped>
	.home-main{
		width: 100%;
		/* padding-bottom: 50px; */
		margin: 0px auto 0;
		line-height: 0px;
	}
	.app-banner{
		width: 100%;
	}
	
	.car-list{
		margin: 20px 0 0;
	}
	.car-list .list-title{
		border-bottom: 1px solid #cc141c;
		height: 44px;
		line-height: 44px;
		font-size: 26px;
		/* margin-bottom: 20px; */
	}
	.car-list .list-title span{
		color: #cc141c;
		margin-left: 16px;
	}
	
	
	
	.car-list-ul{
		flex-wrap: wrap;
	}
	.car-item{
		width: 232px;
		height: 312px;
		border: 1px solid #d4d4d4;
		margin-top: 10px;
		float: left;
		margin-left: 6px;
		cursor: pointer;
		position: relative;
		top: 0;
		left: 0;
	}
	.car-item:hover{
		border: 1px solid #e60717;
	}
	.car-item .car-name{
		height: 30px;
		line-height: 30px;
		font-size: 14px;
		text-align: center;
	}
	.car-item:hover .car-name{
		color: #e60717;
	}
	.car-item .car-detail{
		font-size: 12px;
		padding-left: 9px;
		line-height: 22px;
		color: #000;
		position: relative;
	}
	.car-item .car-detail .price{  
		color: red;
		font-weight: 700;
	}
	.status-icon{
		width: 75px;
		height: 23px;
		position: absolute;
		right: -2px;
		top: 0;
		line-height: 21px;
		color: #fff;
		font-style: normal;
		text-indent: 1em;
		/* background: ; */
		/* background-image: ; */
	}
</style>
<style>
	/* home-banner
	 */

	.el-carousel__item h3 {
	    color: #475669;
	    font-size: 14px;
	    opacity: 0.75;
	    line-height: 150px;
	    margin: 0;
	}
	
	.el-carousel__item:nth-child(2n) {
	     background-color: #99a9bf;
	}
	  
	.el-carousel__item:nth-child(2n+1) {
		background-color: #d3dce6;
	}
	  
	.home-banner .el-carousel__arrow{
		font-size: 50px;
		background-color:transparent;
	}
	.home-banner .el-carousel__arrow:hover{
		background-color:transparent;
	}
</style>